import { render, staticRenderFns } from "./PopupSettings.vue?vue&type=template&id=0612efa2&"
import script from "./PopupSettings.vue?vue&type=script&lang=js&"
export * from "./PopupSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports